import produce from "immer"
import { ASC } from "const"
import { MtTag } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initTag: MtTag = {
    id: null,
    name: "",
}

const initTagState: types.TagState = {
    tagList: {},
    tagIds: [],
    tagEdit: null, // hide edit form when null

    sortColumn: "name",
    sortOrder: ASC,
    filters: {
        search: null,
    },

    reloadList: true,
}

const tagReducer = produce((
    draft: types.TagState = initTagState,
    action: ActionTypes = null,
): types.TagState => {
    switch (action.type) {
        case types.TAG_LIST:
            draft.tagList = action.tagList
            return draft

        case types.TAG_IDS:
            draft.tagIds = action.tagIds
            return draft

        case types.TAG_EDIT:
            draft.tagEdit = action.tag
            return draft

        case types.TAG_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.TAG_FILTERS:
            draft.filters = action.filters
            return draft

        case types.TAG_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        default:
            return draft
    }
})
export default tagReducer
